export const WORK_LANES = "WORK_LANES";
export const WORK_LANES_COUNT = "WORK_LANES_COUNT";
